import { createDetailReducer } from '../../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'RANKINGRULE',
  inside: {
    tournament: { get: 'rankingRules', set: 'rankingRule' },
  },
});
